import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link as MuiLink } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LevavLogo from '../../sources/Logo/LEVAV Logo.png';
import MindverseLogo from '../../sources/Logo/Mindverse Logo.png';
import ChangeLanguage from './ChangeLanguage.js';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';

function AppBar() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const appBarBackgroundColor = "rgba(255, 255, 255, 0.60)";

  const handleNavigation = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${sectionId}`);
    }
    setDrawerOpen(false);
  };

  const navigationLinks = [
    { label: t('TopBar.home'), id: 'introduction' },
    { label: t('TopBar.levav'), id: 'levav' },
    { label: t('TopBar.mindverse'), id: 'mindverse' },
    { label: t('TopBar.contact'), id: 'contactUs' },
  ];

  const MobileDrawer = () => (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      sx={{
        '& .MuiDrawer-paper': {
          zIndex: 1100  // Higher than the AppBar
        }
      }}
    >
      <Box sx={{ width: 250, pt: 10 }}>
        <List>
          {navigationLinks.map((link) => (
            <ListItem 
              button 
              key={link.id}
              onClick={() => handleNavigation(link.id)}
              sx={{ color: '#4e7ba8' }}
            >
              <ListItemText primary={link.label} />
            </ListItem>
          ))}
          <ListItem sx={{ justifyContent: 'center', mt: 2 }}>
            <ChangeLanguage />
          </ListItem>
          <ListItem sx={{ justifyContent: 'center', mt: 2 }}>
            <Button 
              // href="https://levav.com.hk/cms/"
              href="https://levav.co/cms/"
              fullWidth
              sx={{ 
                color: "#ffffff", 
                backgroundColor: '#65cb9a', 
                borderRadius: 2, 
                textTransform: 'none', 
                '&:hover': { backgroundColor: '#1a9f77' }
              }}
            >
              {t('TopBar.loginBtn')}
            </Button>
          </ListItem>
          <ListItem sx={{ justifyContent: 'center', mt: 1 }}>
            <Button 
              onClick={() => {
                navigate('/student-login');
                setDrawerOpen(false);
              }}
              fullWidth
              sx={{ 
                color: "#ffffff", 
                backgroundColor: '#4e7ba8', 
                borderRadius: 2, 
                textTransform: 'none', 
                '&:hover': { backgroundColor: '#3a5f7f' }
              }}
            >
              {t('TopBar.assessmentLoginBtn')}
            </Button>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );

  return (
    <Box sx={{ 
      height: 'auto', 
      width: '100%', 
      backgroundColor: appBarBackgroundColor,
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>
      <Grid 
        container 
        sx={{
          padding: { xs: 2, md: '32px 40px 16px 40px' },
          alignItems: "center",
        }}
      >
        <Grid item xs={isMobile ? 8 : 3} container spacing={2} sx={{ 
          justifyContent: "flex-start", 
          alignItems: "center",
          mt: { xs: 1, md: 0 },
          pl: { xs: 2, md: 0 }
        }}>
          <MuiLink onClick={() => handleNavigation('introduction')} sx={{ cursor: 'pointer' }}>
            <img 
              src={LevavLogo} 
              alt="LEVEV Logo" 
              style={{
                height: isMobile ? '40px' : '50px',
                width: 'auto',
              }}
            />
          </MuiLink>
          <MuiLink onClick={() => handleNavigation('introduction')} sx={{ cursor: 'pointer' }}>
            <img 
              src={MindverseLogo} 
              alt="Mindverse Logo" 
              style={{
                height: isMobile ? '40px' : '50px',
                width: 'auto'
              }}
            />
          </MuiLink>
        </Grid>

        {isMobile ? (
          <Grid item xs={4} container justifyContent="flex-end">
            <IconButton 
              onClick={() => setDrawerOpen(!drawerOpen)}
              sx={{ color: '#4e7ba8' }}
            >
              <MenuIcon />
            </IconButton>
          </Grid>
        ) : (
          <Grid item xs={9} container gap={2} spacing={2} sx={{ 
            justifyContent: "flex-end", 
            alignItems: "center" 
          }}>
            {navigationLinks.map((link) => (
              <MuiLink 
                key={link.id}
                onClick={() => handleNavigation(link.id)} 
                sx={{ 
                  textDecoration: "none", 
                  color: "black", 
                  cursor: 'pointer' 
                }}
              >
                <Typography 
                  sx={{ '&:hover': { textDecoration: 'underline' } }} 
                  color="#4e7ba8"
                >
                  {link.label}
                </Typography>
              </MuiLink>
            ))}
            <Box>
              <ChangeLanguage />
            </Box>
            <Box>
              <Button 
                // href="https://levav.com.hk/cms/"
                href="https://levav.co/cms/"
                sx={{ 
                  color: "#ffffff", 
                  backgroundColor: '#65cb9a', 
                  borderRadius: 2, 
                  textTransform: 'none', 
                  '&:hover': { backgroundColor: '#1a9f77' }
                }}
              >
                {t('TopBar.loginBtn')}
              </Button>
            </Box>
            <Box>
              <Button 
                onClick={() => navigate('/student-login')}
                sx={{ 
                  color: "#ffffff", 
                  backgroundColor: '#4e7ba8', 
                  borderRadius: 2, 
                  textTransform: 'none', 
                  '&:hover': { backgroundColor: '#3a5f7f' }
                }}
              >
                {t('TopBar.assessmentLoginBtn')}
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
      <MobileDrawer />
    </Box>
  );
}

export default AppBar;